import { coalesceLocaleField } from '../helpers/coalesceLocaleField'
import { groq } from 'next-sanity'
import { LocaleId } from '@portfolio/configs'
import { createLinkProjection } from '../projections/createLinkProjection'
import { createRichTextProjection } from '../projections/createRichTextProjection'
import { createMediaProjection } from '../projections/createMediaProjection'

export const createSectionCallToActionProjection = (localeId: LocaleId) => {
  const LINK_PROJECTION = createLinkProjection(localeId)
  const RICH_TEXT_PROJECTION = createRichTextProjection(localeId)
  const MEDIA_PROJECTION = createMediaProjection(localeId)

  return groq`{
        _key,
        _type,
        ${coalesceLocaleField('title', localeId)},
        ${coalesceLocaleField(
          'description',
          localeId,
        )}[]${RICH_TEXT_PROJECTION},
        ${coalesceLocaleField('ctaLabel', localeId)},
        cta${LINK_PROJECTION},
        media${MEDIA_PROJECTION}
      }
  `
}
